import { Link } from 'react-router-dom'
import maharajPortrait from '../../../assets/images/maharaj-ji.png'
import { startingPrice } from '../booking/maharajPricingData'
import { useMaharajTiers } from '../booking/useMaharajTiers'

export default function MaharajDetailsSidebar() {
  const tiers = useMaharajTiers()
  return (
    <aside className="space-y-6 lg:sticky lg:top-28">
      <div className="info-card relative overflow-hidden">
        <span className="corner-flourish tl" aria-hidden="true" />
        <span className="corner-flourish tr" aria-hidden="true" />
        <span className="corner-flourish bl" aria-hidden="true" />
        <span className="corner-flourish br" aria-hidden="true" />
        <div className="h-0.75 w-full bg-linear-to-r from-[#C8922A] via-[#E5A820] to-[#C8922A]" />

        <div className="p-7 space-y-6">
          <div className="flex items-center gap-4 pb-6 border-b border-[#D7C29A]/20">
            <img
              src={maharajPortrait}
              alt="Raju Maharaj Ji"
              className="w-14 h-14 rounded-2xl object-cover shrink-0 border-2 border-secondary/30 shadow-[0_0_0_3px_rgba(242,160,7,.1)]"
            />
            <div className="min-w-0">
              <p className="text-[9px] font-semibold text-secondary uppercase tracking-widest mb-1">✦ Expert Profile ✦</p>
              <p className="text-lg font-cinzel text-[#1C140A] leading-tight truncate">Raju Maharaj Ji</p>
              <span
                className="mt-1.5 inline-flex items-center rounded-full px-2 py-0.5 text-[8px] font-bold uppercase tracking-widest text-[#1C140A]"
                style={{ background: 'linear-gradient(135deg, #D4AF37 0%, #F7D08F 100%)' }}
              >
                VIP Access
              </span>
            </div>
          </div>

          <div className="space-y-2.5">
            {tiers.map((tier) => (
              <div key={tier.key} className="flex items-center justify-between text-xs">
                <span className={tier.recommended ? 'font-semibold text-[#1C140A]' : 'text-[#5C3A18]'}>
                  {tier.label}
                </span>
                <span className={tier.recommended ? 'font-bold text-secondary' : 'font-semibold text-[#1C140A]'}>
                  ₹{tier.price.toLocaleString('en-IN')}
                </span>
              </div>
            ))}
          </div>

          <div className="astro-divider" />

          <div className="flex items-center justify-between">
            <span className="text-xs text-[#5C3A18]">Starting from</span>
            <span className="text-2xl font-cinzel font-bold text-gradient-gold">₹{startingPrice(tiers).toLocaleString('en-IN')}</span>
          </div>

          <Link
            to="/book-maharaj-ji"
            className="hero-btn-primary premium-shine w-full inline-flex items-center justify-center rounded-full px-6 py-3.5 text-sm font-semibold uppercase tracking-[0.12em] whitespace-nowrap"
          >
            Book Audience
          </Link>
          <p className="text-center text-[11px] text-[#8B7355] flex items-center justify-center gap-1.5">
            <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect width="18" height="11" x="3" y="11" rx="2" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            Secure, encrypted checkout
          </p>
        </div>
      </div>

      <div className="info-card p-6 space-y-4">
        <h3 className="text-sm uppercase tracking-[0.3em] text-[#8B7355] font-semibold">Prefer to speak first?</h3>
        <p className="text-sm leading-relaxed text-[#5C3A18]">Our concierge team can walk you through the priority tiers before you book your audience.</p>
        <a
          href="tel:+919091840899"
          className="w-full inline-flex items-center justify-center gap-2 rounded-full border border-[#D7C29A]/30 bg-white px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-[#1C140A] hover:border-secondary transition-colors"
        >
          <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25V16.14a2.25 2.25 0 0 0-1.545-2.14l-4.22-1.354a2.25 2.25 0 0 0-2.586 1.022l-1.411 2.334a15.682 15.682 0 0 1-6.75-6.75l2.334-1.411a2.25 2.25 0 0 0 1.022-2.586l-1.354-4.22A2.25 2.25 0 0 0 6.14 2.25H4.5a2.25 2.25 0 0 0-2.25 2.25v2.25Z" />
          </svg>
          Call +91 90918 40899
        </a>
      </div>
    </aside>
  )
}
